import { useEffect, useState } from "react";
import { KeyRound, Loader2, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import ChangePasswordDialog from "./ChangePasswordDialog";

export default function UserMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [logoutError, setLogoutError] = useState("");
  const forced = !!user?.must_change_password;

  useEffect(() => { if (forced) setOpen(true); }, [forced]);

  const handleLogout = async () => {
    setLoggingOut(true); setLogoutError("");
    try { await logout(); }
    catch { setLogoutError("Çıkış tamamlanamadı. Lütfen tekrar deneyin."); }
    finally { setLoggingOut(false); }
  };

  return (
    <div className="user-menu" data-testid="user-menu">
      <div className="user-chip">
        <span className="user-avatar">{(user?.name || user?.username || "?").slice(0, 1).toUpperCase()}</span>
        <div>
          <b data-testid="user-menu-name">{user?.name}</b>
          <small data-testid="user-menu-role">{user?.role === "admin" ? "Yönetici" : "Kullanıcı"} · {user?.username}</small>
        </div>
      </div>
      <button className="icon-btn" title="Şifre değiştir" data-testid="open-change-password" onClick={() => setOpen(true)}><KeyRound size={16}/></button>
      <button className="icon-btn" title="Çıkış yap" data-testid="logout-button" disabled={loggingOut} onClick={handleLogout}>
        {loggingOut ? <Loader2 size={16} className="spin"/> : <LogOut size={16}/>}
      </button>
      {logoutError && <small role="alert" className="notice error" data-testid="logout-error">{logoutError}</small>}
      <ChangePasswordDialog open={open} onOpenChange={setOpen} forced={forced}/>
    </div>
  );
}
